import nanobus from "../../nanobus";

export default class Playable {
  constructor() {
    this._bus = nanobus();
    this.props = null;
  }
  on() {
    this._bus.on.apply(this._bus, arguments);
  }
  removeListener() {
    this._bus.removeListener.apply(this._bus, arguments);
  }
  removeAllListeners() {
    this._bus.removeAllListeners.apply(this._bus, arguments);
  }
  emit() {
    this._bus.emit.apply(this._bus, arguments);
  }
  onDestroy() {
    this.removeAllListeners();
  }
  canPlayNext() {
    return false;
  }
  canPlayPrev() {
    return false;
  }
  canToggleQuality() {
    return false;
  }
  isLive() {
    return false;
  }
}
